import React, { useEffect } from 'react';
import style from '../../Styles/Order/Order.module.css';
import CheckBox from '../../Components/Html/CheckBox.jsx'
import TextField from '../../Components/Html/TextField';
import Enum  from '../../Common/Enum/Enum';


const IngredientsBeverageCheckboxs = ({ menuItem, checkboxValues, setCheckboxValues }) => {

      const handleCheckboxChange = (id, isChecked) => {
        const clickedIngredient = menuItem.ingredients.find(
          ingredient => ingredient.idmenuchartproduct === id
        );        
        if (clickedIngredient && clickedIngredient.isbeverage === Enum.ISBEVERAGE) {
          if (isChecked){
            const newValues = {};
            menuItem.ingredients.forEach(ingredient => {
              if(ingredient.typeOfHtmlElement === Enum.ISCHECKBOX) {
                if (ingredient.idmenuchartproduct === id) {
                  newValues[ingredient.idmenuchartproduct] = true;
                } else if (ingredient.isbeverage === Enum.ISBEVERAGE) {
                  newValues[ingredient.idmenuchartproduct] = false;
                } else {
                  newValues[ingredient.idmenuchartproduct] = checkboxValues[ingredient.idmenuchartproduct] || false;
                }
              }
            });    
            setCheckboxValues(prev => ({
              ...prev,
              ...newValues
            }));            
          } else {
            setCheckboxValues(prev => ({
              ...prev,
              [id]: false
            }));
          }
        } else {
          setCheckboxValues(prev => ({
            ...prev,
            [id]: isChecked
          }));
        }
      };


  return (
    <div className={style.ingredientsBeverageAuxBlock}>
    <div className={style.ingredientTitle}>
        <div className={style.checkboxestitle}>Elige ingredientes y bebida </div>
    </div>

  <div className={style.ingredientsBeverageSubblock}>
        <div className={style.ingredientsblock}>
          <div className={style.listOfIngredients}>
            {menuItem.ingredients.map(ingredient => (
              ingredient.typeOfHtmlElement === Enum.ISCHECKBOX && ingredient.isbeverage !== Enum.ISBEVERAGE ? (
                <div key={ingredient.idmenuchartproduct} >
                  <div className={style.checkBackground}>
                    <CheckBox
                      name={ingredient.name} 
                      id={ingredient.idmenuchartproduct}
                      checked={checkboxValues[ingredient.idmenuchartproduct] ?? false}
                      onChange={handleCheckboxChange} 
                      isbeverage={ingredient.isbeverage}/>
                    </div>
                </div>
              ) : ingredient.typeOfHtmlElement !== Enum.ISCHECKBOX ? (
                <TextField 
                  key={ingredient.idProduct} 
                  name={ingredient.name} 
                  id={ingredient.idProduct}
                />
              ) : null
            ))}
          </div> 
        </div>   

        <div className={style.beverageblock}>                
          <div className={style.listOfIngredients}>
            {menuItem.ingredients.map(ingredient => (
              ingredient.typeOfHtmlElement === Enum.ISCHECKBOX && ingredient.isbeverage === Enum.ISBEVERAGE ? (
                <div key={ingredient.idmenuchartproduct}>
                  <div className={style.checkBackground}>
                    <CheckBox
                      name={ingredient.name} 
                      id={ingredient.idmenuchartproduct}
                      checked={checkboxValues[ingredient.idmenuchartproduct] ?? false}
                      onChange={handleCheckboxChange}
                      isbeverage={ingredient.isbeverage} />
                   </div>
                </div>
              ) : ingredient.typeOfHtmlElement !== Enum.ISCHECKBOX ? (
                <TextField 
                  key={ingredient.idProduct} 
                  name={ingredient.name} 
                  id={ingredient.idProduct}/>
              ) : null
            ))}
          </div> 
        </div>
  </div>
  </div>
  )
}

export default IngredientsBeverageCheckboxs 